module.exports = __webpack_public_path__ + "img/benoit24.11624476.jpg";